import { render, staticRenderFns } from "./userNotifications.vue?vue&type=template&id=f559b142"
import script from "./userNotifications.vue?vue&type=script&lang=js"
export * from "./userNotifications.vue?vue&type=script&lang=js"
import style0 from "./userNotifications.vue?vue&type=style&index=0&id=f559b142&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports